import styled from 'styled-components'

const StyledCalendarView = styled.div`
  height: 100%;
  overflow: hidden;
`

export default StyledCalendarView
